import React from 'react';
import { WrappedCard } from '../WrappedCard';

interface WingipediaCardProps {
  username?: string;
}

export const WingipediaCard: React.FC<WingipediaCardProps> = ({ username }) => {
  return (
    <WrappedCard className="relative" username={username}>
      <div className="space-y-3 md:space-y-4 relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-yellow-300 to-amber-200 bg-clip-text text-transparent mb-3 md:mb-4 drop-shadow-2xl text-center">
          Part of History
        </h2>
        
        {/* Daisy Yellowstone image */}
        <div className="flex justify-center mb-3 md:mb-4">
          <div className="relative w-full max-w-xs md:max-w-sm">
            <div className="absolute inset-0 bg-yellow-400 blur-3xl opacity-40 animate-pulse"></div>
            <img
              src="https://wingo320.com/daisy_yellowstone_36.png"
              alt="DAISY Yellowstone"
              className="relative w-full h-auto rounded-2xl border-4 border-yellow-400 shadow-2xl"
              style={{ maxHeight: '250px', objectFit: 'cover' }}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          </div>
        </div>
        
        <div className="bg-black/60 backdrop-blur-md rounded-2xl p-4 md:p-5 border-2 border-yellow-400/50 shadow-2xl mb-3 md:mb-4">
          <p className="text-base md:text-lg text-yellow-200 font-semibold text-center italic">
            "She was a complete coquette..."
          </p>
        </div>
        
        <a
          href="https://wingo320.com/wingipedia/daisy"
          target="_blank"
          rel="noopener noreferrer"
          data-no-navigate="true"
          className="block text-center mt-3 md:mt-4 relative z-50"
          style={{ pointerEvents: 'auto', touchAction: 'manipulation' }}
          onClick={(e) => {
            console.log('[DIAG] WingipediaCard link onClick fired');
            e.stopPropagation();
            window.open('https://wingo320.com/wingipedia/daisy', '_blank', 'noopener,noreferrer');
          }}
          onTouchStart={(e) => {
            console.log('[DIAG] WingipediaCard link onTouchStart fired');
            e.stopPropagation();
          }}
          onTouchEnd={(e) => {
            console.log('[DIAG] WingipediaCard link onTouchEnd fired');
            e.stopPropagation();
            window.open('https://wingo320.com/wingipedia/daisy', '_blank', 'noopener,noreferrer');
          }}
          onTouchMove={(e) => {
            console.log('[DIAG] WingipediaCard link onTouchMove fired');
          }}
        >
          <div className="bg-yellow-500/30 backdrop-blur-sm rounded-xl p-3 md:p-4 border-2 border-yellow-500/70 hover:bg-yellow-500/40 hover:border-yellow-400 transition-all shadow-lg">
            <p className="text-sm md:text-base text-yellow-100 font-bold">
              140 years of Daisy - only on Wingipedia
            </p>
          </div>
        </a>
      </div>
    </WrappedCard>
  );
};

